// CORRECT - using default imports
import Hero from '../components/Home/Hero';
import Features from '../components/Home/Features';
import Stats from '../components/Home/Stats';

const Home = () => {
  return (
    <div>
      <Hero />
      <Features />
      <Stats />
      
      {/* Call to Action */}
      <section className="section-padding bg-gradient-to-r from-primary-600 to-primary-800">
        <div className="container-custom text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to Transform Your Business?
          </h2>
          <p className="text-xl text-primary-100 mb-8 max-w-2xl mx-auto">
            Join thousands of businesses that trust Tally Technologies for their digital transformation.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="btn-secondary bg-white text-primary-700 hover:bg-gray-100">
              Schedule a Demo
            </button>
            <button className="btn-primary bg-white text-primary-700 hover:bg-gray-100 border-white">
              Contact Sales
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

// Make sure you have DEFAULT export
export default Home;